const library = {
  eyebrow: '05 — Persona\u2019s',
  titleLead: 'Ontdek de 8',
  titleAccent: 'persona\u2019s.',
  intro: 'Klik op een kaart om te ontdekken wat deze persoon nodig heeft — in werkplek, samenwerking en leiderschap.',
  introMobile: 'Klik op een kaart om te ontdekken wat deze persoon nodig heeft.',
  energyFrom: 'Energie van',
  frustrates: 'Frustreert',
  bricksTitle: 'Bricks — Ideale werkplekmix',
  leadershipTitle: 'Wat helpt in leiderschap',
  // Korte werkpleklabels; de lange varianten staan in resultsCard.
  workplaceLabels: {
    focus: 'Concentratie',
    work: 'Standaard',
    hybride: 'Hybride',
    meeting: 'Overleg',
    project: 'Creatief',
    team: 'Samenwerken',
    learning: 'Leren',
    retreat: 'Rust',
    social: 'Informeel',
  },
};

export default library;
